import { IconButton, Typography } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";

function htmlToText(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html || "";
  return div.textContent || div.innerText || "";
}

export default function AudioField({ question, isSection }: any) {
  const audioText = isSection
    ? question.transcript && htmlToText(question.transcript)
    : question.name;

  const playAudio = () => {
    if (!audioText) return;
    const synth = window.speechSynthesis;
    let voices = synth.getVoices();

    // Choose a German voice
    let germanVoice = voices.find((v) => v.lang.startsWith("de")) || null;

    const utterance = new window.SpeechSynthesisUtterance(audioText);
    utterance.lang = "de-DE";
    if (germanVoice) {
      utterance.voice = germanVoice;
    }
    synth.cancel();
    synth.speak(utterance);
  };

  return (
    <div
      style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 8 }}
    >
      <Typography variant="body2" color="textSecondary">
        {isSection ? "Beschreibung" : `Frage ${question.question_no}`}
      </Typography>
      <IconButton onClick={playAudio}>
        <PlayCircleIcon fontSize="large" />
      </IconButton>
    </div>
  );
}
